import React, { useContext, useState } from 'react';
import { Mui, MuiIcons } from '@leap4/frontend';
import SellerValidation from './sellerValidation';
import SellerChanges from "./sellerChanges";
import { SellerContext } from "./sellerContext";
import {openSellerTextOnNewTab} from "./funcions";

const { Box, Button, Tab, Tabs } = Mui;
const { Refresh: RefreshIcon, OpenInNewOutlined: OpenInNewOutlinedIcon } = MuiIcons;

const SellerTabs = ({ openSellerFile, handleReScrapeLastSeller, reScrapeMutation }) => {
    const { currentSeller, site } = useContext(SellerContext);
    const [tabIndex, setTabIndex] = useState(0);

    // Function to handle tab change
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <Box>
            {/* Tabs and buttons positioned at the top */}
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Tabs value={tabIndex} onChange={handleTabChange}>
                    <Tab label="Sellers.json Validation" />
                    <Tab label="Sellers.json Changes" />
                </Tabs>

                {/* Buttons on the top right */}
                <Box display="flex" gap={2}>
                    {tabIndex === 0 && <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => openSellerTextOnNewTab(currentSeller,true)}
                    >
                        Export Sellers.json
                    </Button>}
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleReScrapeLastSeller}
                        disabled={reScrapeMutation.isLoading}
                        startIcon={<RefreshIcon />}
                    >
                        Re-Scrape
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={openSellerFile}
                        startIcon={<OpenInNewOutlinedIcon />}
                    >
                        GoTo sellers.json
                    </Button>
                </Box>
            </Box>

            {/* Conditional rendering based on tab selection */}
            <Box mt={2}>
                {tabIndex === 0 && <SellerValidation />}
                {tabIndex === 1 && <SellerChanges />}
            </Box>
        </Box>
    );
};

export default SellerTabs;
